import React from 'react';

// SVG Inline
import SVG from 'react-inlinesvg';

import UploadFileSrc from 'assets/images/icons/DesignSysten2.0/document_file/Subir Arquivo.svg';
import DefaultDocumentSrc from 'assets/images/icons/DesignSysten2.0/document_file/Documento Padrão.svg';
import HorizontalDocumentSrc from 'assets/images/icons/DesignSysten2.0/document_file/horizontal_document.svg';
import DocumentWithPhotoSrc from 'assets/images/icons/DesignSysten2.0/document_file/Documento com Foto.svg';
import XlsSrc from 'assets/images/icons/DesignSysten2.0/document_file/Arquivo XLS.svg';
import CsvSrc from 'assets/images/icons/DesignSysten2.0/document_file/Arquivo CSV.svg';
import XmlSrc from 'assets/images/icons/DesignSysten2.0/document_file/Arquivo XML.svg';

interface SVGInlineInterface {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

export const UploadFile: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={UploadFileSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const DocumentWithPhoto: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={DocumentWithPhotoSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const DefaultDocument: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={DefaultDocumentSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
export const HorizontalDocument: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={HorizontalDocumentSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Xlsc: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={XlsSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Xml: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={XmlSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);

export const Csv: React.FC<SVGInlineInterface> = ({
  width = 20,
  height = 20,
  fill = '#14171A',
}) => (
  <SVG
    src={CsvSrc}
    style={{ width, height }}
    cacheRequests
    preProcessor={(code) => code.replace(/fill=".*?"/g, `fill="${fill}"`)}
  />
);
